import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    'hello': '你好，世界',
    'index': {
        name: '首页',
        introduction: '项目介绍',
        battle:'同心抗疫',
        cooperation: '国际合作',
        information: '媒体报道',
        about: '关于我们'
    },
    ...zhLocale
}

export default cn